import { theme, ComponentProps } from 'lib/theme'
import { Button } from 'common/Button'
import { Flex } from 'primitives/Flex'
import { Icon } from 'common/Icon'

export const VideoAssetPlayButton: React.FC<
  {
    show: boolean
    preventPropagation: boolean
    onClick?: (ev: React.MouseEvent<HTMLDivElement>) => void
  } & ComponentProps<typeof Flex>
> = ({ show, preventPropagation = true, onClick, css }) => {
  return (
    <Flex
      column
      center
      css={{
        position: 'absolute',
        width: '100%',
        height: '100%',
        ...css,
      }}
      onClick={(ev) => {
        if (show) {
          if (preventPropagation) ev.stopPropagation()
          onClick?.(ev)
        }
      }}
    >
      <Button
        icon
        css={{
          position: 'absolute',
          transition: 'opacity 125ms ease-in-out',
          opacity: show ? 1 : 0,
          backgroundColor: theme.colors.gray800,
          top: '50%',
          left: '50%',
          transform: 'translate(-50%,-50%)',
          width: '58px',
          height: '58px',
          minWidth: '28px',
          minHeight: '28px',
          ...css,
        }}
      >
        <Icon
          icon='Play'
          iconSize={35}
          css={{
            '& .primary.fill.stroke': {
              fill: '$gray400',
              stroke: '$gray400',
            },
          }}
        />
      </Button>
    </Flex>
  )
}
